// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"5e676161","81":"a8b90192","787":"c5ab03a0"}[chunkId] + ".chunk.js";
};